export const RANKING_SORT_OPTIONS = [
  { id: 'pendiente', label: 'Pendiente' },
  { id: 'score', label: 'Score' },
  { id: 'margen', label: 'Margen' },
];

export function sortClientRanking(rows = [], sortBy = 'pendiente') {
  const list = [...rows];
  if (sortBy === 'score') {
    return list.sort((a, b) => (a.score ?? 101) - (b.score ?? 101));
  }
  if (sortBy === 'margen') {
    return list.sort((a, b) => {
      const aVal = a.margenReal != null ? a.margenReal : a.margenEstimado ?? -Infinity;
      const bVal = b.margenReal != null ? b.margenReal : b.margenEstimado ?? -Infinity;
      return aVal - bVal;
    });
  }
  return list.sort((a, b) => b.pendiente - a.pendiente);
}

export function displayMargen(row) {
  if (row?.margenReal != null) {
    return { value: row.margenReal, label: 'real' };
  }
  if (row?.margenEstimado != null) {
    return { value: row.margenEstimado, label: 'est.' };
  }
  return null;
}
